<template>
  <div class="custom-locale-control-event-edit-container">
    <div class="event-edit-control">
      <el-date-picker
        v-model="dateList"
        type="daterange"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        size="small"
      />
      <el-button type="primary" @click="searchEvent"
        size="small" :loading="searchLoading"
      >查询</el-button>
    </div>
    <div class="event-edit-content">
      <el-scrollbar max-height="25rem">
        <div class="event-edit-row"
          v-for="(event, index) of eventList"
          :key="index"
          :class="{
            'event-edit-row-check': eventCheckIdList.includes(event[eventIdProp]),
          }"
          @click="eventClick(event)"
        >
          <div class="event-edit-row-title ellipsis" :title="event.eventName">
            {{ event.eventName }}
          </div>
          <div class="event-edit-row-info">
            <div>
              {{ event.eventTime }}
            </div>
            <div>
              <img :src="getEventIconUrl(event.typeName === 'C波段干扰' ? '电磁异常' : event.typeName)"> {{ event.typeName }}
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, toRaw
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import { getEventIconUrl, getEventIcon } from '@/utils/js/marker-icon';


import {
  getEventListByCoordinates,
} from '@/api/UserDrawApi';
// props
const props = defineProps({
  target: { type: Object, },
  layer: { type: Object, },
});
// emit
const emit = defineEmits([
  
]);

const editTarget = ref({
  ...props.target,
})

const searchEvent = ()=>{
  if(dateList.value.length < 2){
    message('请选择日期', 2);
    return;
  }
  getEventListByCoordinatesFn(dateList.value.at(0), dateList.value.at(1));
}, searchLoading = ref(false);

const dateList = ref([ dayjs(new Date()).add(-7, 'day') , new Date()]);
const eventProp = ref('eventList');
const eventList = ref(editTarget.value[eventProp.value] || []), eventIdProp = ref('eventNumber'),
      eventCheckIdList = computed(()=>{
        return editTarget.value[eventProp.value].map((event)=> event[eventIdProp.value]);
      }),
      getEventListByCoordinatesFn = (start, end)=>{
        searchLoading.value = true;
        const format = 'YYYY-MM-DD'
        const startTime = dayjs(start).format(format),
              endTime = dayjs(end).format(format);
        const layer = props.layer;
        getEventListByCoordinates({
          minLat: layer.getBounds().getSouthEast().lat,
          minLon: layer.getBounds().getNorthWest().lng,
          maxLat: layer.getBounds().getNorthWest().lat,
          maxLon: layer.getBounds().getSouthEast().lng,
          geom: layer.toGeoJSON && JSON.stringify(layer.toGeoJSON()),
          st: startTime,
          et: endTime,
        }).then(res=>{
          if(res.data.code == 1004){
            eventList.value = [
              ...editTarget.value[eventProp.value],
            ];
            (res.data.data?JSON.parse(res.data.data):[]).forEach(event=>{
              // console.log(eventCheckIdList.value, event);
              if(!eventCheckIdList.value.includes(event.eventNumber)){
                eventList.value.push(event);
              }
            })
          }
          searchLoading.value = false;
        }).catch(err=>{
          searchLoading.value = false;
          console.log(err);
        });
      }

const eventClick = (event)=>{
  if(eventCheckIdList.value.includes(event.eventNumber)){
    const index = editTarget.value[eventProp.value].findIndex(e => {
      return e.eventNumber == event.eventNumber
    });
    editTarget.value[eventProp.value].splice(index, 1);
  }else{
    editTarget.value[eventProp.value].push(event);
  }
  props.target[eventProp.value] = editTarget.value[eventProp.value]
}


// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  if(!editTarget.value[eventProp.value]){
    editTarget.value[eventProp.value] = [];
  }
  getEventListByCoordinatesFn(dateList.value.at(0), dateList.value.at(1));
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.custom-locale-control-event-edit-container{
  table-layout: fixed;
  display: table;
  width: fit-content;
  .event-edit-control{
    width: max-content;
    display: table-row;
  }
  .event-edit-content{
    padding: 5px 0;
    :deep(.el-scrollbar){
      .el-scrollbar__view{
        display: flex;
        flex-direction: column;
        gap: 5px;
      }
    }
    .event-edit-row{
      border-radius: var(--borderRadiusSize_3);
      padding: 5px;
      --rowHeight: 24px;
      background-color: var(--backgroundColor_16);
      .event-edit-row-title, .event-edit-row-info{
        line-height: var(--rowHeight);
        height: var(--rowHeight);
        font-size: 14px;
      }
      .event-edit-row-info{
        display: flex;
        justify-content: space-between;
        img{
          height: 20px;
          aspect-ratio: 1 / 1;
          vertical-align: text-bottom;
        }
        div{
          line-height: var(--rowHeight);
          height: var(--rowHeight);
          &:nth-child(1){
            color: var(--fontColor_12);
          }
          &:nth-child(2){
            background-color: rgba(246, 246, 246, 0.8);
            padding: 0 5px;
            border-radius: var(--borderRadiusSize);
          }
        }
      }
    }
    .event-edit-row-check{
      background-color: var(--backgroundColor_36);
      .event-edit-row-title{
        color: var(--fontColor_8);
      }
      .event-edit-row-info{
        div{
          &:nth-child(2){
            color: var(--fontColor_8);
            background-color: var(--backgroundColor_3);
          }
        }
      }
    }
  }
}
</style>